import { computed, type Ref, watch, type WritableComputedRef } from "vue";
import type { DSBaseListOption, DSListOptions } from "../types";
import { findOptionById, flattenOptions, getOptionId } from "../utils/optionListUtils";

export const useOptionListActiveOption = (
  options: Ref<DSListOptions>,
  activeOptionId: WritableComputedRef<string | undefined> | Ref<string | undefined>,
  resolvedListId: Ref<string>
) => {
  const flatOptions = computed<DSBaseListOption[]>(() => flattenOptions(options.value));

  const activeIndex = computed<number>(() => {
    if (!activeOptionId.value) return -1;
    return flatOptions.value.findIndex(option => getOptionId(resolvedListId.value, option) === activeOptionId.value);
  });

  const isOptionActive = (option: DSBaseListOption): boolean => {
    return getOptionId(resolvedListId.value, option) === activeOptionId.value;
  };

  watch(flatOptions, () => {
    if (!activeOptionId.value) return;
    const activeOption = findOptionById(resolvedListId.value, flatOptions.value, activeOptionId.value);
    if (!activeOption) {
      activeOptionId.value = undefined;
    }
  });

  return {
    flatOptions,
    activeIndex,
    isOptionActive,
  };
};
